export const TRANSPARENT = 'transparent';
export const BURNT_SIENNA = '#EB1875';
export const STEEL_BLUE = '#4477A9';
export const SOLITUDE = '#DBE4EB';
export const SOLITUDE_2 = '#F8F9FA';
export const SOLITUDE_3 = '#EFF2F6';
export const GRAY = '#BDBDBD';
export const GRAY_700 = '#616161';
export const BLACK = '#000';
export const BLACK_2 = '#111';
export const BLACK_3 = '#030303';
export const DANUBE = '#6597C8';
export const MALIBU = '#75B1F5';
export const ATHENS_GRAY = '#F6F6F7';
export const WHITE = '#FFFFFF';
export const REGENT_GREY = '#7B8083';
export const VERY_LIGHT_GREY = '#CCC';
export const VERY_LIGHT_GREY_2 = '#CBCBCB';
export const RED = '#eb1e74';
export const OXFORD_BLUE = '#282F3A';
export const NERO = '#151515';
export const NERO_2 = '#212121';
export const ZIRCON = '#E6E7E9';
export const ZIRCON_2 = '#EFF5FF';
export const GHOST = '#C6C6C8';
export const SUVA_GREY = '#8E8E8E';
export const SUVA_GREY_2 = '#8E8D8D';
export const LILY_WHITE = '#E9EBEA';
export const TIARA = '#BFC1C0';
export const DARK_GRAY = '#AAAAAA';
export const CHOCOLATE = '#E25613';
export const WHITE_SMOKE_1 = '#F9F9F9';
export const WHITE_SMOKE_2 = '#F1F1F1';
export const WHITE_SMOKE_3 = '#F5F5F5';
export const GAINSBORO = '#E5E5E5';
export const EGYPTIAN_BLUE = '#0D47A1';
export const NOBEL = '#999';
export const NOBEL_2 = '#9C9C9C';
export const ATOMIC_TANGERINE = '#FF9B5B';
export const NARY_BLUE = '#07D';
export const LINK_WATER = '#CDCFD5';
export const DIM_GRAY = '#666666';
export const FREE_SPEECH_RED = '#CB0002';
export const MORTAR = '#585858';
export const SILVER = '#C0BFC0';
export const MYSTIC = '#E9EAE9';
export const DODGER_BLUE = '#2196F3';
